import React from 'react';
import { ListGroup, Modal } from 'react-bootstrap';
import moment from '../../moment';

function ProgressNotes({ show, onHide, notes }) {
	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>Notities</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<ListGroup variant="flush">
					{notes.map((note) => (
						<ListGroup.Item key={note.note}>
							<p className="text-body-secondary" style={{ textTransform: 'capitalize' }}>
								{moment(note.date).format('LLLL')}
							</p>
							<p>{note.note}</p>
						</ListGroup.Item>
					))}
				</ListGroup>
			</Modal.Body>
		</Modal>
	);
}

export default ProgressNotes;
